export const NORMAL = 'normal';
export const ACTIVE = 'active';
export const DISABLED = 'disabled';

export default {
  NORMAL,
  ACTIVE,
  DISABLED,
};
